import React from "react";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";

const DoctorOrdersTable = ({ order }) => {
  console.log(order);
  return (
    <tr>
      <td className="h-16 px-6 text-sm transition duration-300 border-slate-200 stroke-slate-500 text-slate-500 ">
        {order?.packageName}
      </td>
      <td className="h-16 px-6 text-sm transition duration-300 border-slate-200 stroke-slate-500 text-slate-500 ">
        {order?.totalPrice}
      </td>
      <td className="h-16 px-6 text-sm transition duration-300 border-slate-200 stroke-slate-500 text-slate-500 ">
        {order?.userName}
      </td>
      <td className="h-16 px-6 text-sm transition duration-300 border-slate-200 stroke-slate-500 text-slate-500 ">
        {order?.userEmail}
      </td>
      <td className="h-16 px-6 text-sm transition duration-300 border-slate-200 stroke-slate-500 text-slate-500 ">
        <button className="bg-green-200 px-3 rounded-full text-secondary py-1 "> {order?.issueDate}</button>
      </td>
      <td className="h-16 px-6 text-sm transition duration-300 border-slate-200 stroke-slate-500 text-slate-500 ">

        <button className="bg-red-200 px-3 rounded-full text-secondary py-1 "> {order?.expireDate}</button>
      </td>
      <td className="h-16 px-6 text-sm transition duration-300 border-slate-200 stroke-slate-500 text-slate-500 ">
        <Link to={`/doctorDashboard/patient-edit-profile/${order?.userId}`}>
          {" "}
          <button className="border border-secondary py-2 px-3 rounded-md hover:bg-secondary/10 duration-300">
            <FaEye />
          </button>
        </Link>
      </td>
     
    </tr>
  );
};

export default DoctorOrdersTable;
